<template>
    <div>
        <div style="margin-top: 0" class="common-table">
            <el-table v-loading="loading" :data="tribeCreate.beanList" row-key="msgId" height="100%">
                <!--<el-table-column type="selection" width="55"/>-->
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="用户ID" align="center" prop="userId"/>
                <el-table-column label="用户昵称" align="center" prop="nickname"/>
                <el-table-column label="俱乐部ID" align="center" prop="clubId"/>
                <el-table-column label="联盟名称" align="center" prop="tribeName"/>
                <el-table-column label="联系方式" align="center" prop="contact"/>
                <el-table-column label="留言框" align="center" prop="message"/>
                <!--<el-table-column label="占成比例" align="center">70%</el-table-column>-->
                <el-table-column label="申请时间" align="center" prop="createTime"/>
                <el-table-column align="center" width="150">
                    <template slot-scope="scope">
                        <el-button type="danger" size="mini" @click="reject(scope.row.msgId)">拒绝</el-button>
                        <el-button type="success" size="mini" @click="setConfigFunc(scope.row)">同意</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination class="common-el-pagination"
                       layout="prev,pager,next,jumper"
                       background
                       :page-size="20"
                       :pager-count="5"
                       :current-page="currentPage"
                       @current-change="getList($event)"
                       :total="tribeCreate.total"/>

        <div v-if="configIsShow" class="common-popup-bg">
            <div class="common-popup">
                <h3>设置条件</h3>
                <el-form :model="configForm">
                    <table class="common-popup-table">
                        <tr>
                            <td>申请人：</td>
                            <td v-text="`${configForm.nickname}(${configForm.userId})`"></td>
                        </tr>
                        <tr>
                            <td>占成率：</td>
                            <td>
                                <el-radio-group v-model="configForm.profit">
                                    <el-radio label="">默认(10%)</el-radio>
                                    <el-radio :label="profitVal">自定义
                                        <el-input size="medium"
                                                  type="number"
                                                  suffix-icon="icon-percent"
                                                  v-model="profitVal"/>
                                    </el-radio>
                                </el-radio-group>

                            </td>
                        </tr>
                        <tr>
                            <td>俱乐部：</td>
                            <td>
                                <el-radio-group v-model="configForm.clubUpperLimit">
                                    <el-radio label="">默认(100)</el-radio>
                                    <el-radio :label="clubUpperLimitVal">自定义
                                        <el-input size="medium"
                                                  type="number"
                                                  min="1"
                                                  max="1000"
                                                  v-model="clubUpperLimitVal"/>
                                    </el-radio>
                                </el-radio-group>

                            </td>
                        </tr>
                        <tr>
                            <td style="display: inline-block">主联盟：</td>
                            <td>
                                <el-radio-group v-model="configForm.mainTribeId">
                                    <el-radio :label="1">设为主联盟</el-radio>
                                    <el-radio class="mainTribeId" :label="mainTribeId">
                                        <el-select
                                                size="medium"
                                                v-model="mainTribeId"
                                                filterable>
                                            <el-option
                                                    v-for="item of mainTribeList.beanList"
                                                    :key="item.mainTribeId"
                                                    :label="item.mainTribeName"
                                                    :value="item.mainTribeId"/>
                                        </el-select>
                                    </el-radio>
                                </el-radio-group>
                            </td>
                        </tr>
                    </table>
                </el-form>
                <footer>
                    <el-button size="small" @click="configIsShow = false">取消</el-button>
                    <el-button size="small" @click="approve" type="primary">确定</el-button>
                </footer>
            </div>
        </div>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                configIsShow: false,
                configForm: {},
                profitVal: 1,
                clubUpperLimitVal: 1,
                mainTribeId: '',//主联盟id
                currentPage: 1
            }
        },
        computed: {
            ...mapState('managementMsg', ['tribeCreate']),
            ...mapState('union', ['mainTribeList'])
        },
        watch: {
            profitVal(newVal) {
                if (newVal === 1) return;
                this.configForm.profit = newVal
            },
            clubUpperLimitVal(newVal) {
                if (newVal === 1) return;
                this.configForm.clubUpperLimit = newVal
            },
            mainTribeId(newVal) {
                if (newVal === '') return;
                this.configForm.mainTribeId = newVal
            }
        },
        created() {
            this.getList();
            this.getMainTribeList();
        },
        methods: {
            ...mapActions('managementMsg', ['getTribeCreateList', 'approveTribeCreate', 'rejectTribeCreate']),
            ...mapActions('union', ['getMainTribeList']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getTribeCreateList(page).then(() => {
                    this.loading = false;
                    if (this.currentPage !== 1 && !this.tribeCreate.beanList.length) {
                        this.getList(this.currentPage - 1)
                    }
                });
            },
            setConfigFunc(row) {
                this.profitVal = 1;
                this.clubUpperLimitVal = 1;
                this.configIsShow = true;
                this.configForm = {
                    userId: row.userId,
                    nickname: row.nickname,
                    msgId: row.msgId,
                    profit: '',
                    clubUpperLimit: '',
                    mainTribeId: 1
                }
            },
            approve() {
                this.approveTribeCreate({
                    clubUpperLimit: this.configForm.clubUpperLimit,
                    msgId: this.configForm.msgId,
                    profit: this.configForm.profit,
                    isMainTribe: this.configForm.mainTribeId === 1 ? 1 : 0,
                    mainTribeId: this.configForm.mainTribeId === 1 ? '' : this.mainTribeId
                }).then(() => {
                    this.configIsShow = false;
                    this.$message.success('申请已批准');
                    this.getList(this.currentPage);
                })
            },
            reject(msgId) {
                this.loading = true;
                this.rejectTribeCreate(msgId).then(() => {
                    this.$message.success('申请已拒绝');
                    this.getList(this.currentPage);
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .mainTribeId {
        display: block;
        margin-top:10px;
        :global(.el-input) {
            width: 100% !important;
        }
    }
</style>
